import type { PersistedStateOptions } from "pinia-plugin-persistedstate";

/**
 * @description pinia持久化参数配置
 * @param {String} key 存储到持久化的 name
 * @param {Array} paths 需要持久化的 state name
 * @return persist
 * */
const piniaPersistConfig = (key: string, local?: boolean, paths?: string[]) => {
  const persist: PersistedStateOptions = {
    key,
    storage: local ? window.localStorage : window.sessionStorage,
    // storage: window.sessionStorage,
    paths,
  };
  return persist;
};

export default piniaPersistConfig;
